export default __webpack_public_path__ + "static/media/logo.62ff7b95.svg";